import React, { createContext, useContext, useState, useEffect } from 'react';
import { login as apiLogin, getMe, seedData } from '../lib/api';
import { storeAuth, clearAuth, getStoredToken, getStoredUser } from '../lib/authStorage';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = getStoredToken();
    const savedUser = getStoredUser();
    
    if (token && savedUser) {
      try {
        await getMe();
        setUser(savedUser);
      } catch (error) {
        console.error('Auth check failed:', error.message);
        clearAuth();
      }
    }
    setLoading(false);
  };

  const login = async (email, password) => {
    try {
      const response = await apiLogin(email, password);
      const { access_token, user: userData } = response.data;
      
      storeAuth(access_token, userData);
      setUser(userData);
      
      return { success: true };
    } catch (error) {
      if (error.response?.status === 401) {
        try {
          await seedData();
          const response = await apiLogin(email, password);
          const { access_token, user: userData } = response.data;
          
          storeAuth(access_token, userData);
          setUser(userData);
          
          return { success: true };
        } catch (seedError) {
          console.error('Seed+login failed:', seedError.message);
          return { 
            success: false, 
            error: seedError.response?.data?.detail || 'Credenciales invalidas' 
          };
        }
      }
      console.error('Login failed:', error.message);
      return { 
        success: false, 
        error: error.response?.data?.detail || 'Error al iniciar sesion' 
      };
    }
  };

  const logout = () => {
    clearAuth();
    setUser(null);
  };

  const isDirection = () => user?.role === 'direccion';
  const isReception = () => user?.role === 'recepcion';

  return (
    <AuthContext.Provider value={{ 
      user, 
      loading, 
      login, 
      logout, 
      isDirection, 
      isReception 
    }}>
      {children}
    </AuthContext.Provider>
  );
};
